export default {
  default: {
    timeOnPage: {
      title: 'Average Time on Page',
    },
  },
}
